import { makeVar, useReactiveVar } from '@apollo/client';
import { nanoid } from 'nanoid';
import { useCallback } from 'react';

type ActivityBuilderRequest = {
  requestIds: Map<string, string>;
};

export const activityBuilderRequest = makeVar<ActivityBuilderRequest>({
  requestIds: new Map(),
});

export const useActivityBuilderRequest = () => {
  const data = useReactiveVar(activityBuilderRequest);

  const createRequest = useCallback(
    (contentId: string) => {
      const requestId = nanoid();
      data.requestIds.set(requestId, contentId);
      activityBuilderRequest({ ...data });
      return requestId;
    },
    [data]
  );

  const clearRequest = useCallback(
    (id: string) => {
      if (data.requestIds.get(id)) {
        data.requestIds.delete(id);
        activityBuilderRequest({ ...data });
      }
    },
    [data]
  );

  return {
    data,
    createRequest,
    clearRequest,
    hasInFlightRequest: data.requestIds.size > 0,
  };
};
